import React from "react";
import {Button} from "primereact/button";
import {LoginComponentProps} from "@/components/login/login.props";
import {Card} from "primereact/card";

const LoginComponent: React.FC<LoginComponentProps> = ({onLogin, titleCard, imgUrl, contentText}) => {

    const handleLogin = () => {
        if (onLogin) {
            onLogin(true);
        }
    };
    const header = (
        <div className={"flex justify-center items-center border-solid border-0 border-b border-gray-300 p-2"}>
            <img alt="Card" src={imgUrl ?? "/images/logo-bb-color.png"}/>
        </div>
    );
    const footer = (
        <div style={{margin: 'auto', textAlign: 'center'}}>
            <Button onClick={handleLogin}
                className="btn-login"
                // className="w-full border-0 bg-primary-500 hover:bg-primary-600 rounded-md shadow-md hover:shadow-lg"
                label="Iniciar Sesión"/>
        </div>
    );


    return (
        <div style={{
                 display: 'flex',
                 justifyContent: 'center',
                 alignItems: 'center',
                 height: '100vh', 
                 backgroundImage: 'url(/images/fondo-login.jpg)',
                 backgroundSize: 'cover',
                 backgroundPosition: 'center',
                 margin: 0,
                 padding: 0
             }}>
            <div className="bg-white rounded-lg shadow-lg  sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4">
                <Card title={titleCard ?? "Compra de Cartera: Common"} footer={footer} header={header}>
                    <p>{contentText ?? ""}</p>
                </Card>
            </div>
        </div>
    )
}

export default LoginComponent;
